import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';

const S = {
  Dialog: styled(Dialog)`
    .MuiPaper-root {
      width: 280px;
      padding: 8px;
      border-radius: 2px;
    }
  `,
  DialogTitle: styled(DialogTitle)`
    padding: 24px 16px;
  `,
  DialogHeading: styled.h3`
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2;
    color: rgba(0, 0, 0, 0.87);
  `,
  Heading: styled.h3`
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    text-align: center;
  `,
  DialogContent: styled(DialogContent)`
    padding: 0 16px 32px 12px;
  `,
  DialogActions: styled(DialogActions)`
    padding: 0 16px;
  `,
  Button: styled(Button)`
    min-width: 0;
    padding: 10px 12px 9px 12px;
    color: #0c8d6d;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    :disabled {
      opacity: 0.3;
      color: #0c8d6d;
    }
  `,
};

const OtherResponseDialog = ({
  children, open, onCancel, onClose, disabled, name,
}) => (
  <S.Dialog open={open} onClose={onClose} name={name}>
    <S.DialogTitle disableTypography>
      <S.DialogHeading>
        기타 의견 쓰기
      </S.DialogHeading>
    </S.DialogTitle>
    <S.DialogContent>
      {children}
    </S.DialogContent>
    <S.DialogActions>
      <S.Button type="button" onClick={onCancel}>
        취소
      </S.Button>
      <S.Button type="button" onClick={onClose} disabled={disabled} name={name}>
        확인
      </S.Button>
    </S.DialogActions>
  </S.Dialog>
);

OtherResponseDialog.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  name: PropTypes.string,
};

OtherResponseDialog.defaultProps = {
  name: '',
};

export default OtherResponseDialog;
